export const TWO_FACTOR_PROMPT_DISMISSED_KEY_PREFIX = '2faSetupPromptDismissed';

export const TIN_PROMPT_SEEN_KEY_PREFIX = 'tinCapturePromptSeen';

// Prompt flags that must survive localStorage.clear() on logout, login and
// account switch. Add new prompt prefixes here.
export const PERSISTENT_PROMPT_KEY_PREFIXES = [
  TWO_FACTOR_PROMPT_DISMISSED_KEY_PREFIX,
  TIN_PROMPT_SEEN_KEY_PREFIX,
];

export const snapshotLocalStorageKeysByPrefix = (
  prefix: string,
): Record<string, string> => {
  const snapshot: Record<string, string> = {};

  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    const value = key ? localStorage.getItem(key) : null;

    if (key?.startsWith(`${prefix}_`) && value !== null) {
      snapshot[key] = value;
    }
  }

  return snapshot;
};

export const restoreLocalStorageSnapshot = (
  snapshot: Record<string, string>,
) => {
  Object.entries(snapshot).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

export const snapshotPersistentPromptKeys = (): Record<string, string> =>
  PERSISTENT_PROMPT_KEY_PREFIXES.reduce<Record<string, string>>(
    (snapshot, prefix) =>
      Object.assign(snapshot, snapshotLocalStorageKeysByPrefix(prefix)),
    {},
  );
